import { apiAuth, apiResponseType } from ".";
import { CashFlowSituation } from "@/types/cashFlow";

export type CashFlowFilters = {
  date_start_payment?: string;
  date_end_payment?: string;
  unity_id?: string | number;
  transaction_type_id?: string | number;
  per_page?: number;
  situation?: CashFlowSituation;
  page?: number;
};

export const getFinancialCashFlowData = (
  params: CashFlowFilters = {}
): apiResponseType => {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      queryParams.append(key, value.toString());
    }
  });

  return apiAuth.get(
    `financial-cash-flow?${queryParams.toString()}`
  ) as apiResponseType;
};
